/**
 * Correlação de uma modal-session com o resto do sistema (viagem, pedido de
 * serviço, roteiro em cena). Separado de `session.ts` pelo teto de linhas do
 * gate (`max-lines`); `session.ts` importa e o barrel reexporta.
 */

import { z } from 'zod';

/**
 * LINHAGEM de roteiro: a sessão nasceu da busca de UM trecho de um card
 * multi-trecho em cena — `challengeId` é o do card (o mesmo que o submit
 * `select_multi_leg_fares` ecoa) e `legIndex` o trecho buscado. É a chave FORTE
 * da adoção no agente: uma oferta desta sessão pertence a este trecho por
 * identidade, não por parecer com ele (rota/data). Sem ela o agente compara
 * rota+data, e um metro pedido (`SAO`) contra o aeroporto voado (`GRU`)
 * recusava um roteiro legítimo.
 */
export const ModalSessionItineraryLineageSchema = z
  .object({
    challengeId: z.string().min(1),
    legIndex: z.number().int().min(0),
  })
  .strict();
export type ModalSessionItineraryLineage = z.infer<typeof ModalSessionItineraryLineageSchema>;

export const ModalSessionCorrelationSchema = z
  .object({
    tripId: z.string().min(1).optional(),
    serviceRequestId: z.string().min(1).optional(),
    itinerary: ModalSessionItineraryLineageSchema.optional(),
  })
  .strict();
export type ModalSessionCorrelation = z.infer<typeof ModalSessionCorrelationSchema>;
